import React from "react";
import { Quote } from "lucide-react";
import { useSiteContent, getSection } from "../../context/SiteContentContext";

const FALLBACK = {
    eyebrow: "Quem já provou",
    title_pre: "Palavra de quem serve",
    title_highlight: "todos os dias.",
    items: [
        {
            quote: "O expositor da Sabor Líquido paga-se sozinho. Zero desperdício de fruta e os clientes voltam pelo sabor.",
            author: "Marta S.",
            role: "Café Central · Braga",
        },
        {
            quote: "Finalmente sumo natural sem ter de gerir fruta fresca. A qualidade é constante o ano inteiro.",
            author: "Ricardo P.",
            role: "Brunch & Co. · Lisboa",
        },
        {
            quote: "Os meus filhos pedem o de morango todas as manhãs. Nota-se que é só fruta, mais nada.",
            author: "Inês M.",
            role: "Cliente · Porto",
        },
    ],
};

export const Testimonials = () => {
    const { content } = useSiteContent();
    const cms = getSection(content, "testimonials", {});
    const c = { ...FALLBACK, ...cms };
    const items = c.items?.length ? c.items : FALLBACK.items;

    return (
        <section
            id="testemunhos"
            data-testid="testimonials-section"
            className="py-20 md:py-28 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                        {c.eyebrow}
                    </span>
                    <h2 className="mt-3 font-display font-medium text-4xl md:text-5xl text-brand-ink leading-tight">
                        {c.title_pre}{" "}
                        <span className="italic text-brand-orange">
                            {c.title_highlight}
                        </span>
                    </h2>
                </div>
                <div className="mt-12 grid md:grid-cols-3 gap-5">
                    {items.map((t, i) => (
                        <figure
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className={`rounded-2xl p-7 flex flex-col ${
                                i === 0
                                    ? "bg-brand-ink text-white md:-mt-4"
                                    : "bg-brand-cream text-brand-ink"
                            }`}
                        >
                            <Quote
                                className={`h-6 w-6 ${
                                    i === 0 ? "text-brand-orange" : "text-brand-orange/60"
                                }`}
                            />
                            <blockquote className="mt-4 font-display font-medium text-xl leading-snug flex-1">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-6">
                                <div className="text-sm font-bold">{t.author}</div>
                                <div
                                    className={`text-xs mt-0.5 ${
                                        i === 0 ? "text-white/60" : "text-brand-ink-soft"
                                    }`}
                                >
                                    {t.role}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};
